export function formatPercent(value?: number): string {
  if (value === undefined) {
    return "-";
  }
  const formated = Number(value).toLocaleString("EN", {
    maximumFractionDigits: 2,
  });
  return `${formated}%`;
}
